const CLIENT_NAME = 'trace'

const CLIENT_HEADER_ROUTES =
  /\/auth\/(signup|login|logout|social\/[^/]+|password\/(forgot|reset|change))\/?$/

export const getClientHeader = (url: string): Record<string, string> => {
  const path = url.split(/[?#]/)[0]

  return CLIENT_HEADER_ROUTES.test(path) ? { 'X-Client': CLIENT_NAME } : {}
}
